export const videoEmbedGql = /* GraphQL */ `... on landingPageContent2023_videoEmbed_BlockType {
    typeHandle
    embedStyle
    captionColor
    video {
        title
        __typename
        ... on videos_Asset {
            videoDuration
            videoId
            videoDescription
            caption
            image:lpBackgroundWide {
                srcWebp
                srcset
            }
        }
        ... on videoUploads_Asset {
            videoDescription
            caption
            videoDuration
            url
            videoThumbnail {
                ... on images_Asset {
                    image:uncropped1920w {
                        srcWebp
                        srcset
                    }
                }
            }
        }
    }
}`;